/** @format */

import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../constants/api";
import apiClient from "../utils/apiClient";

export const apiJustificativeStatusList = (): Promise<AxiosResponse<unknown>> => {
  return apiClient.get(API_ENDPOINTS.JUSTIFICATIVE_STATUSES);
};
